/**
 * CONSTANT: Translations
 * @type {Object}
 *
 * This constant contains all of the disclaimer data for display within the application.
 * It"s constructed as a JSON object, which can be used by both Vue and PDFMake.js
 */

const strings = {

	// // TEST STRINGS
	// "test.homepage" : {
	// 	"en": "This is a home page",
	// 	"fr": "Ceci est une page d'accueil"
	// },

	// "test.local" : {
	// 	"en": "This is the dashboard page",
	// 	"fr": "Ceci est la page du tableau de bord"
	// },

	"test.intro" : {
		"en": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut  laboris nisi ut aliquip ex ea commodo consequat.",
		"fr": "Ut  laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
	},


	// UI ------------------------------------------------------------------------------ //

	"ui.logo": {
		"en": "REALTOR.ca Logo",
		"fr": "Logo de REALTOR.ca"
	},

	"ui.card.reveal": {
		"en": "Reveal rear",
		"fr": "Montrer l’endos"
	},

	"ui.share.facebook": {
		"en": "Share on Facebook",
		"fr": "Partager sur Facebook"
	},

	"ui.share.twitter": {
		"en": "Share on Twitter",
		"fr": "Partager sur Twitter"
	},

	"ui.share.linkedin": {
		"en": "Share on LinkedIn",
		"fr": "Partager sur LinkedIn"
	},

	"ui.share.email": {
		"en": "Share via Email",
		"fr": "Partager par courriel"
	},

	"ui.nodata": {
		"en": "No data available.",
		"fr": "Pas de données disponibles"
	},

	"nav.btn.local": {
		"en": "Local Insights",
		"fr": "Données locales"
	},


	"nav.btn.report": {
		"en": "Insights Report",
		"fr": "Données générales"
	},

	// ILLUSTRATIONS -------------------------------------------------------------------- //

	"ui.icons.average-listings": {
		"en": "Houses with speech bubbles containing hearts",
		"fr": "Des maisons avec des bulles de texte contenant des cœurs"
	},

	"ui.icons.average-mobile-time": {
		"en": "Hand holding a mobile device",
		"fr": "Une main tenant un appareil mobile"
	},

	"ui.icons.aware-realtor": {
		"en": "Users aware of REALTOR.ca",
		"fr": "Des utilisateurs qui connaissent REALTOR.ca"
	},

	"ui.icons.market-share": {
		"en": "An agent with a pie chart",
		"fr": "Un agent avec un diagramme circulaire"
	},

	"ui.icons.visitor-growth": {
		"en": "A chart combining a line graph and bar graph",
		"fr": "Un graphique combinant un tableau linéaire et un tableau à barres"
	},

	"ui.icons.buying-stages": {
		"en": "Illustration of buying stages",
		"fr": "Une illustration du processus d’achat"
	},

	"ui.icons.younger-audience": {
		"en": "Younger home buyers visiting REALTOR.ca",
		"fr": "Les jeunes acheteurs de maisons visitant REALTOR.ca"
	},

	"ui.icons.calls-realtor": {
		"en": "Rushing mobile device",
		"fr": "Un appareil mobile en mouvement"
	},

	"ui.icons.device-desktop": {
		"en": "Desktop computer",
		"fr": "Un ordinateur de bureau"
	},

	"ui.icons.device-phone": {
		"en": "Mobile phone",
		"fr": "Un cellulaire"
	},

	"ui.icons.device-source-hub": {
		"en": "User with desktop, tablet and mobile devices",
		"fr": "Un utilisateur avec un ordinateur de bureau, une tablette et des appareils mobiles"
	},

	"ui.icons.device-tablet": {
		"en": "Tablet",
		"fr": "Une tablette"
	},

	"ui.icons.email-friend": {
		"en": "Email a friend",
		"fr": "Courriel à un ami"
	},

	"ui.icons.email-offices": {
		"en": "Email an office",
		"fr": "Courriel au bureau"
	},

	"ui.icons.email-realtor": {
		"en": "Email a REALTOR®",
		"fr": "Courriel au courtier ou à l’agent"
	},

	"ui.icons.filters": {
		"en": "Three different houses",
		"fr": "Trois maisons différentes"
	},

	"ui.icons.first-time-buyer": {
		"en": "A simple house",
		"fr": "Une seule maison"
	},

	"ui.icons.gender-f": {
		"en": "Female",
		"fr": "Une femme"
	},

	"ui.icons.gender-m": {
		"en": "Male",
		"fr": "Un homme"
	},

	"ui.icons.house-sale": {
		"en": "House for sale",
		"fr": "Une maison à vendre"
	},

	"ui.icons.illustration": {
		"en": "Default illustration",
		"fr": "Une illustration par défaut"
	},

	"ui.icons.list-quill": {
		"en": "A list with a quill",
		"fr": "Une liste avec une plume"
	},

	"ui.icons.list": {
		"en": "A list with a quill",
		"fr": "Une liste avec une plume"
	},

	"ui.icons.mobile-apps": {
		"en": "Mobile app with a notification",
		"fr": "Une application mobile avec une notification"
	},

	"ui.icons.profile-views": {
		"en": "Desktop profile view",
		"fr": "Un profil sur un ordinateur de bureau"
	},

	"ui.icons.visitors-to-leads": {
		"en": "An illustration of a tablet and various website actions",
		"fr": "Une illustration d'une tablette et de diverses actions de site Web"
	},

	"ui.icons.reach-out-realtor": {
		"en": "Three houses together with a REALTOR® and client",
		"fr": "Trois maisons avec un courtier ou agent et un client"
	},

	"ui.icons.realtor-users": {
		"en": "REALTOR.ca user",
		"fr": "Un utilisateur de REALTOR.ca"
	},

	"ui.icons.realtors-visitors": {
		"en": "Six users at a desktop",
		"fr": "Six utilisateurs devant un ordinateur de bureau"
	},

	"ui.icons.renter": {
		"en": "An apartment building",
		"fr": "Un immeuble d’appartements"
	},

	"ui.icons.repeat-buyer": {
		"en": "Two simple houses",
		"fr": "Deux maisons"
	},

	"ui.icons.residential-investor": {
		"en": "A house with a line chart",
		"fr": "Une loupe et un utilisateur"
	},

	"ui.icons.search-realtor": {
		"en": "A magnifying glass and a user",
		"fr": "Un appareil mobile avec des notifications en forme de cœur"
	},

	"ui.icons.social-shares": {
		"en": "A mobile device with heart notifications",
		"fr": "Un utilisateur, un ordinateur de bureau et différentes sources de trafic"
	},

	"ui.icons.livestream": {
		"en": "File and a film reel",
		"fr": "Fichier et une bobine de film"
	},

	"ui.icons.tours": {
		"en": "A video camera together with play and pause icons",
		"fr": ""
	},

	"ui.icons.traffic-sources": {
		"en": "A user, desktop and different traffic sources",
		"fr": "Un utilisateur près d’un ordinateur de bureau affichant un nombre de visites."
	},

	"ui.icons.visits-desktop": {
		"en": "User beside a desktop showing visits",
		"fr": "Un utilisateur près d’un appareil mobile affichant un nombre de visites."
	},

	"ui.icons.visits-mobile": {
		"en": "User beside a mobile device showing visits",
		"fr": "Utilisateur à côté d'un appareil mobile affichant des visites"
	},

	"ui.icons.visits-page": {
		"en": "Browser window",
		"fr": "Une fenêtre de navigateur"
	},

	"ui.icons.visits-realtor": {
		"en": "User getting a notification on a mobile",
		"fr": "Un utilisateur recevant une notification sur un appareil mobile"
	},

	"ui.icons.laptop": {
		"en": "Hands typing on an open laptop",
		"fr": "Mains tapant sur un ordinateur portable ouvert"
	},

	"ui.icons.website": {
		"en": "Website on a desktop",
		"fr": "Un site Web sur un ordinateur de bureau"
	},

	"ui.icons.svg.email": {
		"en": "Email icon",
		"fr": "Icône de messagerie électronique"
	},

	"ui.icons.svg.facebook": {
		"en": "Facebook icon",
		"fr": "Icône de Facebook"
	},

	"ui.icons.svg.linkedin": {
		"en": "LinkedIn icon",
		"fr": "Icône de LinkedIn"
	},

	"ui.icons.svg.pinterest": {
		"en": "Pinterest icon",
		"fr": "Icône de Pinterest"
	},

	"ui.icons.svg.twitter": {
		"en": "Twitter icon",
		"fr": "Icône de Twitter"
	},

	"ui.icons.svg.justbrowsing": {
		"en": "Just browsing icon",
		"fr": "Icône Simple exploration"
	},

	"ui.icons.svg.serioushunters": {
		"en": "Serious hunters icon",
		"fr": "Icône Recherche sérieuse"
	},

	"ui.icons.svg.gettingstarted": {
		"en": "Getting started icon",
		"fr": "Icône Début des recherches"
	},

	"ui.icons.svg.justpurchased": {
		"en": "Just purchased icon",
		"fr": "Icône Nouveau propriétaire"
	},

	"ui.icons.international-visitors": {
		"en": "A global user of REALTOR.ca",
		"fr": "Un utilisateur mondial de REALTOR.ca"
	},

	"ui.icons.international-leads": {
		"en": "A magnifying glass searching locations around the globe",
		"fr": "Une loupe à la recherche de lieux dans le monde entier"
	},

	"ui.icons.svg.arrowdown": {
		"en": "An icon of arrow pointing down.",
		"fr": "Une icône de flèche pointant vers le bas."
	},

	"ui.icons.svg.arrowright": {
		"en": "An icon of arrow pointing right.",
		"fr": "Une icône de flèche pointant vers la droite."
	},

	"ui.icons.svg.realtor-logo": {
		"en": "Realtor Logo",
		"fr": "Logo de Realtor"
	},

	"ui.icons.svg.info": {
		"en": "An icon of the information symbol.",
		"fr": "Une icône du symbole d'information."
	},

	// UI Charts ----------------------------------------------------------------------- //

	"ui.charts.visitor-trendline" : {
		"en": "An area chart showing the visitor trendline continuing to grow, hitting its peak in August",
		"fr": "Un montrant la courbe du tendance en matière d’inscriptions qui continue de croître, atteignant son apogée en août"
	},

	"ui.charts.listing-trendline": {
		"en": "An area chart showing the listing trendline peaking in May",
		"fr": "Un montrant la ligne de tendance de la liste culminant en mai"
	},


	"ui.charts.organic-search": {
		"en": "A bar chart showing organic search visitors increasing compared to the previous year.",
		"fr": "Un graphique à barres montrant l'augmentation du nombre de visiteurs issus de la recherche organique par rapport à l'année précédente."
	},


	// import Email from '@/icons/email.svg';
	// import Facebook from '@/icons/facebook.svg';
	// import LinkedIn from '@/icons/linkedin.svg';
	// import Pinterest from '@/icons/pinterest.svg';
	// import Twitter from '@/icons/twitter.svg';

	// import JustBrowsing from '@/icons/just-browsing.svg';
	// import SeriousHunters from '@/icons/serious-hunters.svg';
	// import GetingStarted from '@/icons/getting-started.svg';
	// import JustPurchased from '@/icons/just-purchased.svg';

	// META INFO ----------------------------------------------------------------------- //

	"report.pagetitle": {
		"en": "REALTOR.ca Local Insights",
		"fr": "Données locales de REALTOR.ca"
	},

	"report.description": {
		"en": "Discover what REALTOR.ca visitors are looking for in the areas you care about.",
		"fr": "Découvrez ce que les visiteurs de REALTOR.ca cherchent dans les régions qui sont importantes pour vous."
	},

	"local.pagetitle": {
		"en": "REALTOR.ca Local Insights",
		"fr": "Données locales de REALTOR.ca"
	},

	"local.description": {
		"en": "Discover what REALTOR.ca visitors are looking for in the areas you care about.",
		"fr": "Découvrez ce que les visiteurs de REALTOR.ca cherchent dans les régions qui sont importantes pour vous."
	},

	// REPORT INTRO -------------------------------------------------------------------- //

	"report.pagetitle": {
		"en": "REALTOR.ca Insights Report : 2021 Update",
		"fr": "Rapport sur les données d’utilisation de REALTOR.ca : Mise à jour 2021"
	},

	"report.pagetitle.image.alt": {
		"en": "Happy couple browsing REALTOR.ca",
		"fr": "Un couple heureux faisant des recherches sur REALTOR.ca."
	},

	"report.intro.title": {
		"en": "REALTOR.ca Insights Report",
		"fr": "Rapport sur les données d’utilisation de REALTOR.ca"
	},

	"report.intro.subheading": {
		"en": "Consumers and REALTORS® trust REALTOR.ca",
		"fr": "Les consommateurs et les courtiers et agents immobiliers font confiance à REALTOR.ca"
	},

	"report.intro.content": {
		"en": " ",
		"fr": " "
	},

	"report.intro.contentB": {
		"en": " ",
		"fr": " "
	},

	"report.intro.year": {
		"en": "A Look at 2021",
		"fr": "Retour sur 2021"
	},

	"report.intro.share": {
		"en": "Share this report",
		"fr": "Partager ce rapport"
	},

	// INSIGHTS REPORT ----------------------------------------------------------------- //

	"m.insights.title" : {
		"en": "Consumers and REALTORS® trust REALTOR.ca",
		"fr": "Les consommateurs et les courtiers et agents immobiliers font confiance à REALTOR.ca"
	},

	"m.insights.background.alt" : {
		"en": "Young couple preparing to enter a house with a REALTOR®",
		"fr": "Un jeune couple accompagné d’un courtier ou agent s’apprêtant à entrer dans une maison."
	},

	"m.insights.intro.a": {
		"en": "REALTOR.ca, Canada’s No. 1 real estate platform, is a trusted resource owned by REALTORS® and has one primary objective: to support your business.",
		"fr": "REALTOR.ca, la plateforme immobilière la plus populaire au Canada, est une ressource fiable qui appartient aux membres de l’ACI. Son seul objectif fondamental est d’appuyer leurs activités."
	},

	"m.insights.intro.b": {
		"en": "With more listings than any other real estate platform in Canada, it’s the only site in the country combining feeds from every real estate board and association MLS® System.",
		"fr": "Regroupant plus d’inscriptions que toute autre plateforme immobilière au Canada, c’est le seul site au pays qui diffuse les données des systèmes MLS® de toutes les chambres et associations immobilières."
	},

	"m.numbers.title" : {
		"en": "2021 By the Numbers:",
		"fr": "2021 en chiffres"
	},

	"m.numbers.intro": {
		"en": "REALTOR.ca continues to exhibit record growth",
		"fr": "REALTOR.ca continue d’afficher une croissance record"
	},

	"m.trendline.card.a.heading": {
		"en": "Visitor Trendline",
		"fr": "Tendance en matière de visiteurs"
	},

	"m.trendline.card.a.text": {
		"en": "The number of visitors to REALTOR.ca increased&nbsp;53%&nbsp;over 2020.",
		"fr": "Le nombre de visiteurs de REALTOR.ca a augmenté de 53&nbsp;% par rapport à 2020."
	},

	"m.trendline.card.b.heading": {
		"en": "Listing Trendline",
		"fr": "Tendance en matière d’inscriptions"
	},

	"m.trendline.card.b.text": {
		"en": "The number of listings decreased 24% on average when compared to 2020.",
		"fr": "Le nombre d’inscriptions a diminué d’en moyenne 24&nbsp;% par rapport à 2020."
	},

	"m.trendline.market.paragraph.text": {
		"en": "Find out how these trends affected the Canadian real estate market in our 2021 Housing Market Snapshot. Plus, check out CREA Stats for the latest monthly snapshots, quarterly forecasts and more.",
		"fr": "Consultez notre Portrait du marché de l’habitation pour 2021 pour savoir comment ces tendances ont influé sur les prix sur le marché immobilier canadien. Rendez-vous également au Centre de statistiques de l’ACI pour obtenir le dernier portrait du marché de l’habitation mensuel, les prévisions trimestrielles et plus&nbsp;encore."
	},

	"m.trendline.market.link.a.text": {
		"en": "Download 2021 <br/>Snapshot",
		"fr": "Télécharger le Portait pour 2021"
	},

    "m.trendline.market.link.a.url": {
        "en": "https://www.realtor.ca/blog/record-low-supply-and-price-gains-how-canadas-housing-market-fared-in-2021/24248/3195",
        "fr": "https://www.realtor.ca/blogue/creux-historique-de-loffre-et-hausse-des-prix-r%C3%A9trospective-du-march%C3%A9-de-lhabitation-canadien-en-2021/24277/3197"
    },

	"m.trendline.market.link.b.text": {
		"en": "CREA Stats",
		"fr": "Centre de statistiques de&nbsp;l’ACI"
	},

    "m.trendline.market.link.b.url": {
        "en": "https://creastats.crea.ca/en-CA/",
        "fr": "https://creastats.crea.ca/fr-CA/"
    },

	"m.trendline.market.btn.text": {
		"en": "Download 2021 Snapshot",
		"fr": "Découvrez quelle est l’incidence de cette situation sur les prix dans le marché immobilier!"
	},

	"m.numbers.paragraph.a": {
		"en": "REALTOR.ca’s brand trust and awareness among Canadians continues to grow; in 2021 the site experienced its most significant traffic increase to date reaching a new milestone of more than half a billion visits, by 111 million visitors.",
		"fr": "La confiance accordée par les Canadiens à la marque REALTOR.ca, ainsi que la popularité de la marque chez ces derniers, continuent de croître. En 2021, le site a connu sa plus importante augmentation de l’achalandage à ce jour en atteignant un sommet sans précédent de plus d’un demi-milliard de visites effectuées par 111 millions de visiteurs."
	},

	"m.numbers.paragraph.b": {
		"en": "The substantial growth in traffic seen in 2020 persisted throughout 2021 and was particularly strong early in the year. On the other hand, the supply of listings continues to dwindle with even fewer available listings for sale on the market compared to last year. As real estate supply remains tight, there is a continued imbalance between supply and demand.",
		"fr": "L’importante croissance de l’achalandage observée en 2020 s’est poursuivie en 2021 et a été particulièrement forte en début d’année. En outre, l’offre continue de s’amenuiser : il y a encore moins d’inscriptions de propriétés à vendre que l’année dernière. Comme l’offre immobilière demeure serrée, le déséquilibre entre l’offre et la demande se maintient."
	},

	"m.numbers.card.a.stat" : {
		"en": "<span class=\"stat__number\">87%</span>",
		"fr": "<span class=\"stat__number\">87&nbsp;%</span>"
	},

	"m.numbers.card.a.text" : {
		"en": "According to a 2021 Nanos research study, 87% of Canadians who are in the market for a new home are aware of REALTOR.ca.",
		"fr": "Selon une étude réalisée par Nanos Research en 2021, 87&nbsp;% des Canadiens qui cherchent une nouvelle propriété connaissent REALTOR.ca."
	},

	"m.numbers.card.b.stat" : {
		"en": "<span class=\"stat__number\">6.2</span> million",
		"fr": "<span class=\"stat__number\">6,2</span> millions"
	},

	"m.numbers.card.b.text" : {
		"en": "REALTOR.ca sent 6.2 million leads to REALTORS® in 2021. That’s a 36% increase over last year!",
		"fr": "REALTOR.ca a dirigé 6,2 millions de clients potentiels vers nos membres en 2021. Il s’agit d’une augmentation de 36&nbsp;% par rapport à l’année dernière!"
	},

	"m.numbers.card.b.highlight" : {
		"en": "On average, 59 leads are sent to REALTORS® every five minutes! These leads are exclusively available to you as a benefit of your CREA membership.",
		"fr": "En moyenne, 59 clients potentiels sont dirigés vers nos membres toutes les cinq minutes – un des nombreux avantages de l’adhésion à l’ACI."
	},

	"m.numbers.card.c.stat" : {
		"en": "<span class=\"stat__number\">23%</span>",
		"fr": "<span class=\"stat__number\">23&nbsp;%</span>"
	},

	"m.numbers.card.c.text" : {
		"en": "Despite already being the No.1 real estate platform in Canada, REALTOR.ca saw a 23% rise in market share in 2021, increasing to encompass almost 50% of all activity in the Canadian real estate industry for similar&nbsp;platforms.",
		"fr": "Bien que REALTOR.ca soit déjà la plateforme immobilière la plus populaire au Canada, le site a vu sa part de marché augmenter de 23&nbsp;% en 2021 et possède maintenant près de 50&nbsp;% de tout le marché des plateformes immobilières canadiennes&nbsp;semblables."
	},

	"m.numbers.card.d.stat" : {
		"en": "<span class=\"stat__number\">53%</span>",
		"fr": "<span class=\"stat__number\">53&nbsp;%</span>"
	},

	"m.numbers.card.d.text" : {
		"en": "While the overall online Canadian real estate landscape saw 13% more visitors than in 2020, REALTOR.ca visitor growth significantly outpaced that rate with a 53% increase.",
		"fr": "Alors que l’ensemble du marché immobilier canadien en ligne a enregistré une hausse de visiteurs de 13&nbsp;% comparativement à 2020, la croissance du nombre de visiteurs de REALTOR.ca a largement dépassé ce taux avec une hausse de 53&nbsp;%."
	},

	// "m.numbers.card.d.rear" : {
	// 	"en": "264,000 residential listings and 88,000 commercial listings on average.",
	// 	"fr": "264 000 inscriptions résidentielles et 88 000 inscriptions commerciales"
	// },

	// CONSUMER HIGHLIGHTS ------------------------------------------------------------- //

	"m.consumer.title": {
		"en": "Consumer Highlights",
		"fr": "Données sur les consommateurs"
	},

	"m.consumer.background.alt" : {
		"en": "Happy couple using a laptop after moving into a new home.",
		"fr": "Un couple heureux qui vient d’emménager dans une nouvelle habitation et qui utilise un ordinateur portable."
	},

	"m.insights.intro": {
		"en": "Let’s take a closer look at how the behaviour of REALTOR.ca visitors has evolved this year.",
		"fr": "Examinons de plus près en quoi le comportement des visiteurs a évolué cette année."
	},

	"m.visitors.title": {
		"en": "How Visitors Arrive at REALTOR.ca",
		"fr": "Comment les visiteurs se rendent-ils sur REALTOR.ca?"
	},

	"m.visitors.intro.a": {
		"en": "As a result of REALTOR.ca’s brand recognition, most website visitors (42%) come directly to REALTOR.ca to begin their property search. Overall, the amount of direct traffic to REALTOR.ca is 16% higher when compared to the proportion of direct visits to other real estate websites.",
		"fr": "Comme la marque REALTOR.ca est reconnue, la plupart des visiteurs du site Web&nbsp;(42&nbsp;%) s’y rendent directement pour commencer leur recherche de propriétés. Dans l’ensemble, le volume de l’achalandage direct sur REALTOR.ca est de 16&nbsp;% plus élevé que celui d’autres sites Web d’annonces immobilières."
	},

	"m.visitors.intro.b": {
		"en": "68% of organic search traffic coming to REALTOR.ca results from branded search terms, which further highlights Canadians' awareness of the REALTOR.ca brand.",
		"fr": "Soixante-huit pour cent des visites sur REALTOR.ca attribuables au référencement naturel découlent d’une recherche de termes associés à la marque, ce qui témoigne de la reconnaissance de la marque REALTOR.ca chez les Canadiens."
	},

	"m.breakdown.title": {
		"en": "Visitor Breakdown",
		"fr": "Répartition des visiteurs"
	},

	"m.breakdown.intro.a": {
		"en": "In 2021, REALTOR.ca saw a 12% decrease in the proportion of first-time home buyers to the platform. In contrast, there were more repeat buyers and investors who visited the site.",
		"fr": "En 2021, le nombre de visiteurs de REALTOR.ca cherchant une première propriété a diminué de 12&nbsp;%, alors que les acheteurs déjà propriétaires et les investisseurs ont été plus nombreux à visiter le site."
	},

	"m.breakdown.intro.b": {
		"en": "On search engines like Google, for example, REALTOR.ca ranks No. 1 for real estate and has increased its organic search market share by 33%. Furthermore, REALTOR.ca’s organic search market share for top real estate search terms has increased more than&nbsp;100%.",
		"fr": "Sur des moteurs de recherche comme Google, par exemple, REALTOR.ca se classe au premier rang pour l’immobilier et a augmenté sa part de marché du référencement naturel de 33&nbsp;%. De plus, la part de marché de REALTOR.ca pour les principaux termes de recherche immobilière a augmenté de plus de 100&nbsp;%."
	},

	"m.breakdown.card.a.stat": {
		"en": "<span class=\"stat__number\">72%</span> Organic search<br /> traffic increase",
		"fr": "<span class=\"stat__number\">72%</span> Augmentation de l’achalandage généré par le référencement naturel"
	},

	"m.breakdown.card.a.text": {
		"en": "Driven by strong brand recognition and search engine optimization efforts, in 2021, REALTOR.ca’s organic search traffic rose&nbsp;72%.",
		"fr": "Grâce à la forte reconnaissance de la marque et aux efforts d’optimisation pour les moteurs de recherche, en 2021, l’achalandage généré par le référencement naturel de REALTOR.ca a augmenté&nbsp;de 72&nbsp;%."
	},

	"m.breakdown.card.b.stat" : {
		"en": "<span class=\"stat__number\">46%</span> Repeat Buyers",
		"fr": "<span class=\"stat__number\">46&nbsp;%</span> Acheteurs déjà propriétaires"
	},

	"m.breakdown.card.b.text" : {
		"en": "46% of visitors are repeat buyers. On average, they visited REALTOR.ca eight more times compared to first-time home buyers.",
		"fr": "46&nbsp;% des visiteurs de REALTOR.ca sont déjà propriétaires. En moyenne, ils ont visité REALTOR.ca huit fois de plus que les acheteurs d’une première propriété."
	},

	"m.breakdown.card.b.reverse": {
		"en": "This group is primarily (63%) between the ages of 25 and 54.",
		"fr": "Ce groupe de visiteurs se situait principalement (63&nbsp;%) dans la tranche des 25 à 54 ans."
	},

	"m.breakdown.card.c.stat" : {
		"en": "<span class=\"stat__number\">38%</span> First-Time Home Buyers",
		"fr": "<span class=\"stat__number\">38&nbsp;%</span> Acheteurs d’une première propriété"
	},

	"m.breakdown.card.c.reverse.a": {
		"en": "More than 60% of first-time home buyers on REALTOR.ca hoped to complete their transaction within the year, and 31% of those indicated they were looking to complete it within three months.",
		"fr": "Plus de 60&nbsp;% des acheteurs d’une première propriété qui visitent REALTOR.ca espèrent conclure leur transaction d’ici un an, et 31&nbsp;% d’entre eux ont indiqué qu’ils cherchent à conclure leur transaction d’ici trois mois."
	},

	"m.breakdown.card.c.text" : {
		"en": "This group represents 38% of visitors and skews younger; they’re typically (51%) in the 18 to 34 age&nbsp;range. ",
		"fr": "Ce groupe représente 38&nbsp;% des visiteurs et une tranche d’âge plus jeune; ils se situent généralement (51&nbsp;%) dans la tranche d’âge des 18 à 34 ans."
	},

	"m.breakdown.card.d.stat" : {
		"en": "<span class=\"stat__number\">8%</span> Residential Investors",
		"fr": "<span class=\"stat__number\">8&nbsp;%</span> Investisseurs résidentiels"
	},

	"m.breakdown.card.e.stat" : {
		"en": "<span class=\"stat__number\">8%</span> Other",
		"fr": "<span class=\"stat__number\">8&nbsp;%</span> Autres"
	},

	"m.breakdown.paragraph.b": {
		"en": "The primary motivation indicated for first-time home buyers and sellers to complete a real estate transaction is a change in family status.",
		"fr": "Ce qui motive principalement les acheteurs et les propriétaires-vendeurs d’une première propriété à conclure une transaction immobilière est un changement de l’état familial."
	},

	"m.breakdown.paragraph.c" : {
		"en": "Alternatively, repeat buyers and sellers have indicated they’re more likely to purchase or sell real estate because of a lifestyle change.",
		"fr": "En revanche, les acheteurs déjà propriétaires et les propriétaires-vendeurs qui reviennent sur le marché ont indiqué qu’ils sont plus susceptibles d’acheter ou de vendre en raison d’un changement de style de vie."
	},

	"m.breakdown.infobox.a" : {
		"en": "Here’s some helpful resources to share with your clients:",
		"fr": "Voici quelques ressources utiles à partager avec vos clients :",
	},

    "m.breakdown.link.a.text" : {
        "en": "Home Buyer's <br> Road Map",
        "fr": "Feuille de route en vue de l’achat d’une maison",
    },

    "m.breakdown.link.a.url" : {
        "en": "https://www.realtor.ca/resource/homebuyers_road_map.pdf",
        "fr": "https://www.realtor.ca/ressource/feuille_de_route_en_vue_de_lachat_dune_maison.pdf",
    },

    "m.breakdown.link.b.text" : {
        "en": "Mortgage <br />Calculators",
        "fr": "Calculatrices <br />hypothécaires",
    },

    "m.breakdown.link.b.url" : {
        "en": "https://www.realtor.ca/calculator#v=payment",
        "fr": "https://www.realtor.ca/calculatrice#v=payment",
    },


	// Visitor Breakdown
	"m.visitorviews.title": {
		"en": "Visitors and Views",
		"fr": "Visiteurs et pages consultées"
	},

	"m.visitorviews.card.a.stat": {
		"en": "<span class=\"stat__number\">111</span> million",
		"fr": "<span class=\"stat__number\">111</span> millions"
	},

	"m.visitorviews.card.a.text": {
		"en": "REALTOR.ca had 111 million visitors in 2021.",
		"fr": "REALTOR.ca a eu 111&nbsp;millions de visiteurs en 2021."
	},

	"m.visitorviews.card.a.highlight": {
		"en": "This is a 53% increase from 2020!",
		"fr": "Une hausse de 53&nbsp;% comparativement à 2020!"
	},

	"m.visitorviews.card.b.stat": {
		"en": "<span class=\"stat__number\">516</span> million",
		"fr": "<span class=\"stat__number\">516</span> millions"
	},

	"m.visitorviews.card.b.text": {
		"en": "REALTOR.ca was visited 516 million times.",
		"fr": "REALTOR.ca a été consulté 516&nbsp;millions de fois."
	},

	"m.visitorviews.card.b.highlight": {
		"en": "This is an increase of 38% from 2020.",
		"fr": "Une augmentation de 38&nbsp;% comparativement à 2020."
	},

	"m.visitorviews.card.c.stat": {
		"en": "<span class=\"stat__number\">1.9</span> billion",
		"fr": "<span class=\"stat__number\">1,9</span> milliard"
	},

	"m.visitorviews.card.c.text": {
		"en": "REALTOR.ca visitors looked at property pages 1.9&nbsp;billion&nbsp;times.",
		"fr": "Les visiteurs de REALTOR.ca ont consulté les pages de propriétés 1,9&nbsp;milliard&nbsp;de&nbsp;fois."
	},

	"m.visitorviews.card.c.highlight": {
		"en": "That’s an average of 213,000 property views per hour!",
		"fr": "C’est en moyenne 213 000 pages consultées à l’heure!"
	},

	"m.visitorviews.card.d.stat": {
		"en": "<span class=\"stat__number\">15.7</span> million",
		"fr": "<span class=\"stat__number\">15,7</span> millions"
	},

	"m.visitorviews.card.d.text": {
		"en": "REALTOR® profiles were viewed 15.7 million times in 2021. On average, REALTOR® profiles are viewed 1,795 times per hour.",
		"fr": "En 2021, le profil des courtiers et agents a été consulté 15,7 millions de fois. Une moyenne de 1&nbsp;795&nbsp;profils à l’heure."
	},

	"m.visitorviews.card.d.highlight": {
		"en": "This represents a 43% increase from 2020.",
		"fr": "Cela représente une hausse de 43&nbsp;% comparativement&nbsp;à&nbsp;2020."
	},

	// Profile Update
	"m.profileupdate.paragraph.text": {
		"en": "Is your REALTOR® profile up to date? Add a photo, introduction video and more to help clients get to know you.",
		"fr": "Votre profil est-il à jour? Ajoutez une photo, une vidéo de présentation et plus encore pour aider les clients à vous connaître.",
	},

	"m.profileupdate.link.text": {
		"en": "Visit member.REALTOR.ca to update your profile",
		"fr": "Visitez membre.REALTOR.ca pour mettre à jour votre&nbsp;profil.",
	},

    "m.profileupdate.link.href": {
        "en": "https://member.realtor.ca/Realtor/MyProfile.aspx",
        "fr": "https://membre.realtor.ca/Realtor/MyProfile.aspx",
    },

	// Visitor Leads
	"m.visitorleads.title": {
		"en": "Turning Visitors into Leads",
		"fr": "De visiteurs à clients potentiels"
	},

	"m.visitorleads.paragraph.a": {
		"en": "REALTOR.ca is designed to help turn visitors into leads. The site generated 6.2 million leads in 2021 through “Email a REALTOR®”, “Email Office”, “Phone a REALTOR®”, and REALTOR.ca DDF®. Of those leads, 93% were focused on residential properties and the other 7% on commercial. Visitors who became leads through REALTOR.ca spent almost twice as long on the site per visit and visited REALTOR.ca seven times more compared to those who did not convert to leads.",
		"fr": "REALTOR.ca est conçu pour aider à ce que les visiteurs deviennent des clients potentiels. Le site a dirigé 6,2 millions de clients potentiels vers des courtiers et agents en 2021 grâce aux boutons Courriel au courtier ou à l’agent, Courriel au bureau et Appeler le courtier ou l’agent ainsi qu’au SDD<sup>MC</sup> de REALTOR.ca. De ce nombre de clients potentiels, 93 % étaient à la recherche d’une propriété résidentielle et 7 % étaient à la recherche d’une propriété commerciale. Les visiteurs qui sont devenus des clients potentiels grâce à REALTOR.ca ont passé presque deux fois plus de temps sur le site par visite et ont visité le site sept fois plus que ceux qui ne sont pas devenus des clients potentiels."
	},

	"m.visitorleads.paragraph.b": {
		"en": " ",
		"fr": " "
	},

	"m.visitorleads.paragraph.c": {
		"en": "REALTOR.ca generated 27.2 million connections to help promote your business.",
		"fr": "REALTOR.ca a permis d’établir 27,2&nbsp;millions de liens pour vous aider à faire prospérer vos affaires."
	},

	// Card A - Visitors
	"m.visitorleads.card.visitors.stat": {
		"en": "<span class=\"stat__number\">3</span> million",
		"fr": "<span class=\"stat__number\">3</span> millions"
	},

	"m.visitorleads.card.visitors.text": {
		"en": "visitors to REALTOR® websites",
		"fr": "de visiteurs sur les sites Web des courtiers et agents"
	},

	"m.visitorleads.card.visitors.rear": {
		"en": "<span class=\"title\">Residential:</span> 2.9M <span class=\"title\">Commercial:</span> 148K",
		"fr": "<span class=\"title\">Inscriptions résidentielles :</span> 2,9 M <span class=\"title\">Inscriptions commerciales :</span> 148 k"
	},


	// Card B - Phone Calls
	"m.visitorleads.card.phone.stat": {
		"en": "<span class=\"stat__number\">3</span> million",
		"fr": "<span class=\"stat__number\">3</span> millions"
	},

	"m.visitorleads.card.phone.text": {
		"en": "phone calls to REALTORS®",
		"fr": "d’appels aux courtiers et agents"
	},

	"m.visitorleads.card.phone.rear": {
		"en": "<span class=\"title\">Residential:</span> 2.9M <span class=\"title\">Commercial:</span> 149K",
		"fr": "<span class=\"title\">Inscriptions résidentielles :</span> 2,9 M <span class=\"title\">Inscriptions commerciales :</span> 149 k"
	},


	// Card C - Searches
	"m.visitorleads.card.searches.stat": {
		"en": "<span class=\"stat__number\">1.4</span> million",
		"fr": "<span class=\"stat__number\">1,4</span> million"
	},

	"m.visitorleads.card.searches.text": {
		"en": "searches for REALTORS®",
		"fr": "de recherches de courtier ou agent"
	},

	"m.visitorleads.card.searches.rear": {
		"en": "<span class=\"title\">Residential:</span> 1.3M <span class=\"title\">Commercial:</span> 136K",
		"fr": "<span class=\"title\">Inscriptions résidentielles :</span> 1,3 M <span class=\"title\">Inscriptions commerciales :</span> 136 k"
	},


	// Card D - Friends
	"m.visitorleads.card.shares.stat": {
		"en": "<span class=\"stat__number\">16.5</span> million",
		"fr": "<span class=\"stat__number\">16,5</span> millions"
	},

	"m.visitorleads.card.shares.text": {
		"en": "social shares",
		"fr": "de partages sur les médias sociaux"
	},

	"m.visitorleads.card.shares.rear": {
		"en": "<span class=\"title\">Residential:</span> 16.2M <span class=\"title\">Commercial:</span> 303K",
		"fr": "<span class=\"title\">Inscriptions résidentielles :</span> 16,2 M <span class=\"title\">Inscriptions commerciales :</span> 303 k"
	},


    // Card E - Virtual Tours
    "m.visitorleads.card.tours.stat": {
        "en": "<span class=\"stat__number\">45</span> million",
        "fr": "<span class=\"stat__number\">45</span> millions"
    },

	"m.visitorleads.card.tours.text": {
		"en": "interactions with virtual/video tours!",
		"fr": "d’interactions avec les vidéos et les visites virtuelles!"
	},


	"m.visitorleads.card.tours.rear": {
		"en": "This is a 54% increase from 2020!",
		"fr": "Une hausse de 54 % comparativement à&nbsp;2020!"
	},

    // Card F - Emails
    "m.visitorleads.card.emails.stat": {
        "en": "<span class=\"stat__number\">2.6</span> million",
        "fr": "<span class=\"stat__number\">2,6</span> millions"
    },

    "m.visitorleads.card.emails.text": {
        "en": "emails to REALTORS®",
        "fr": "de courriels aux courtiers et agents"
    },

    "m.visitorleads.card.emails.rear": {
        "en": "<span class=\"title\">Residential:</span> 2.3M <span class=\"title\">Commercial:</span> 235K",
        "fr": "<span class=\"title\">Inscriptions résidentielles :</span> 2,3 M <span class=\"title\">Inscriptions commerciales :</span> 235 k"
    },

    // Card G - Additional Emails
    "m.visitorleads.card.additionalemails.stat": {
        "en": "<span class=\"stat__number\">+ 650,000</span>",
        "fr": "<span class=\"stat__number\">+ 650&nbsp;000</span>"
    },

    "m.visitorleads.card.additionalemails.text": {
        "en": "additional emails to REALTORS® through REALTOR.ca DDF®",
        "fr": "de courriels additionnels envoyés par l’entremise du SDD<sup>MC</sup> de REALTOR.ca"
    },

    // Card H - Office
    "m.visitorleads.card.office.stat": {
        "en": "<span class=\"stat__number\">23,896</span>",
        "fr": "<span class=\"stat__number\">23&nbsp;896</span>"
    },

    "m.visitorleads.card.office.text": {
        "en": "emails to REALTOR®&nbsp;offices",
        "fr": "de courriels aux bureaux"
    },

    "m.visitorleads.card.office.rear": {
        "en": "<span class=\"title\">Residential:</span> 22.0K <span class=\"title\">Commercial:</span> 1.8K",
        "fr": "<span class=\"title\">Inscriptions résidentielles :</span> 22 k <span class=\"title\">Inscriptions commerciales :</span> 1,8 k"
    },


	// Brokers
	"m.brokers.paragraph.text": {
		"en": "Are you a broker?  Maximize your brokerage’s listing exposure with today REALTOR.ca DDF®.",
		"fr": "Êtes-vous un dirigeant d’agence immobilière? Maximisez la visibilité des inscriptions de votre agence dès aujourd’hui grâce au SDD<sup>MC</sup> de REALTOR.ca."
	},

	"m.brokers.link.a.text": {
		"en": "Learn more",
		"fr": "En savoir plus"
	},

    "m.brokers.link.a.href": {
        "en": "https://www.crea.ca/realtor-members/data-distribution-facility-ddf",
        "fr": "https://www.crea.ca/fr/realtor-members/data-distribution-facility-ddf/"
    },

	"m.brokers.link.b.text": {
		"en": "Update your opt-in settings on member.REALTOR.ca",
		"fr": "Mettre à jour les paramètres sur membre.REALTOR.ca pour s’inscrire"
	},

    "m.brokers.link.b.href": {
        "en": "https://member.realtor.ca/dashboard/Settings/Member",
        "fr": "https://membre.realtor.ca/dashboard/Settings/Member"
    },


	// BEHAVIOURAL INSIGHTS ------------------------------------------------------------ //

	"m.behavioural.title": {
		"en": "Behavioural Insights",
		"fr": "Données comportementales"
	},

	"m.behavioural.background.alt" : {
		"en": "Woman browsing REALTOR.ca listings on her phone",
		"fr": "Une femme regardant des inscriptions de REALTOR.ca sur son téléphone."
	},

	"m.behavioural.intro": {
		"en": "Knowing which stage a potential buyer is in, and who else might be a part of the decision-making process, is important in positioning your listings properly. This can help indicate the best time to start a conversation.",
		"fr": "Savoir à quelle étape du processus se trouve un client potentiel – et savoir qui d’autre pourrait participer à la prise de décision – est primordial pour positionner correctement vos inscriptions. Vous pourrez ainsi déterminer le meilleur moment pour entamer la conversation."
	},

	"m.stages.title.a": {
		"en": "Home Buying Stages",
		"fr": "Étapes du processus d’achat d’une propriété"
	},

	"m.stages.intro.a": {
		"en": "Regardless of which home buying stage a visitor is in, most people tend to reach out to a REALTOR® when they're ready to view properties. Our data shows visitors who are in the “Just browsing” or “Getting started” stages are more likely to reach out to a REALTOR® earlier in the home buying process than those who fall into the other categories.",
		"fr": "Généralement, peu importe l’étape du processus d’achat d’une propriété à laquelle ils se trouvent, la plupart des gens ont tendance à faire affaire avec un courtier ou un agent lorsqu’ils sont prêts à visiter des propriétés. Selon nos données, les visiteurs qui ne font qu’une simple exploration ou qui commencent leur recherche sont également plus susceptibles de communiquer avec un courtier ou un agent tôt dans le processus que ceux qui se trouvent dans les autres catégories."
	},

	"m.stages.title.b": {
		"en": "More serious buyers",
		"fr": "Acheteurs plus sérieux"
	},

	"m.stages.intro.b": {
		"en": "In 2021, REALTOR.ca saw an increase in visitors seriously looking to purchase real estate. For the first time in more than five years, the majority of REALTOR.ca visitors indicated they were serious buyers.",
		"fr": "En 2021, REALTOR.ca a enregistré une hausse du nombre de visiteurs cherchant sérieusement à acheter une propriété. Pour la première fois en plus de cinq ans, la plupart des visiteurs de REALTOR.ca ont indiqué qu’ils étaient des chercheurs sérieux."
	},

	// "m.stages.lastparagraph": {
	// 	"en": "Regardless of which home buying stage a visitor is in, most visitors tend to reach out to a REALTOR® when they are ready to view properties. At the same time, visitors who are “just browsing” or “getting started” are more likely to reach out to REALTORS® earlier in the home buying process when they are searching for properties.",
	// 	"fr": "Peu importe l’étape du processus d’achat d’une propriété à laquelle ils se trouvent, la plupart des visiteurs ont tendance à faire affaire avec un courtier ou un agent lorsqu’ils sont prêts à visiter des propriétés. Parallèlement, les visiteurs qui ne font qu’une simple exploration ou qui débutent leurs recherches sont plus susceptibles de communiquer avec un courtier ou un agent tôt dans le processus lorsqu’ils cherchent des propriétés."
	// },

	// Just Browsing
	"m.stages.browsing.title": {
		"en": "Just browsing",
		"fr": "Simple exploration"
	},

	"m.stages.browsing.description": {
		"en": "The majority of these visitors are looking to complete their transaction in the next year or more.",
		"fr": "La majorité de ces visiteurs cherchent à conclure leur transaction d’ici un&nbsp;an&nbsp;ou&nbsp;plus."
	},

	"m.stages.browsing.stattext": {
		"en": "of those who are “just browsing” are currently working with a REALTOR®.",
		"fr": "de ceux qui font une simple exploration travaillent avec un courtier ou&nbsp;un&nbsp;agent."
	},

	// Serious Hunters
	"m.stages.hunters.title": {
		"en": "Seriously hunting",
		"fr": "Recherche sérieuse"
	},

	"m.stages.hunters.description": {
		"en": "The majority of these visitors are looking to complete their transaction within six months.",
		"fr": "La majorité de ces visiteurs cherchent à conclure leur transaction d’ici six&nbsp;mois."
	},

	"m.stages.hunters.stattext": {
		"en": "of those who are “seriously hunting” are currently working with a REALTOR®.",
		"fr": "de ceux qui font une recherche sérieuse travaillent avec un courtier ou&nbsp;un&nbsp;agent."
	},


	// Getting Startd
	"m.stages.started.title": {
		"en": "Getting started",
		"fr": "Début des recherches"
	},

	"m.stages.started.description": {
		"en": "The majority of these visitors are looking to complete their transaction in the next four months to two years.",
		"fr": "La majorité de ces visiteurs cherchent à conclure leur transaction d’ici quatre&nbsp;mois à deux ans."
	},

	"m.stages.started.stattext": {
		"en": "of those who are “getting started” are currently working with a REALTOR®.",
		"fr": "de ceux qui commencent leur recherche travaillent avec un courtier ou un agent."
	},

	// Just purchased
	"m.stages.purchased.title": {
		"en": "Just purchased",
		"fr": "Nouveau propriétaire"
	},


	"m.stages.purchased.description": {
		"en": "Visitors who identify as having just purchased a property.",
		"fr": "Ces visiteurs indiquent qu’ils viennent d’acquérir une propriété."
	},

	"m.listingstats.paragraph.text": {
		"en": "The REALTOR.ca Listing Stats app is a convenient tool designed for you to connect with leads and clients! Download the app today: ",
		"fr": "L’application REALTOR.ca – Mes stats est un outil pratique conçu pour vous permettre de communiquer avec vos clients actuels et potentiels! <br/> Téléchargez-la dès aujourd’hui&nbsp;: "
	},

    // Apple store badge image src
    "m.listingstats.applestore.src": {
        "en": "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1591228800&h=0347c20784fc18bb5231c89d4c689010",
        "fr": "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/fr-ca?size=250x83&amp;releaseDate=1591228800&h=0347c20784fc18bb5231c89d4c689010"
    },

    // Apple store badge image href
    "m.listingstats.applestore.href": {
        "en": "https://apps.apple.com/us/app/realtor-ca-listing-stats/id1478005795?itsct=apps_box_badge&amp;itscg=30200",
        "fr": "https://apps.apple.com/ca/app/realtor-ca-listing-stats/id1478005795?l=fr"
    },

    // Apple store badge image alt
    "m.listingstats.applestore.alt": {
        "en": "Download on the App Store",
        "fr": "Télécharger dans l'App Store"
    },

    // Google Play badge image src
    "m.listingstats.googleplay.src": {
        "en": "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png",
        "fr": "https://play.google.com/intl/fr_ca/badges/static/images/badges/fr_badge_web_generic.png"
    },

    // Google Play badge image href
    "m.listingstats.googleplay.href": {
        "en": "https://play.google.com/store/apps/details?id=ca.crea.app.member&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
        "fr": "https://play.google.com/store/apps/details?id=ca.crea.app.member&hl=fr"
    },

    // Google Play badge image alt
    "m.listingstats.googleplay.alt": {
        "en": "Get it on Google Play",
        "fr": "Disponible sur Google Play"
    },

	"m.usage.covid.title": {
		"en": "COVID&#8209;19 Pandemic Impact on Buyer and Seller Intentions",
		"fr": "Incidence de la pandémie de la COVID-19 sur les intentions des acheteurs et des propriétaires-vendeurs"
	},

	"m.usage.covid.a": {
		"en": "As the COVID-19 pandemic persists, 31% of survey respondents indicated it has impacted their intention to buy or sell real estate.",
		"fr": "Alors que la pandémie de la COVID-19 persiste, 31 % des répondants au sondage ont indiqué qu’elle avait eu un impact sur leur intention d’acheter ou de vendre une propriété."
	},

	"m.usage.covid.b": {
		"en": "While in-person viewings of listings remain a challenge, many respondents also cited affordability as a barrier to buying due to the high demand and limited supply of housing. Some buyers have also reevaluated their search criteria as higher home prices and the newfound possibility of remote work weigh into the decision.",
		"fr": "Bien que les visites en personne demeurent un défi, de nombreux répondants ont également cité l’abordabilité comme un obstacle à l’achat en raison de la forte demande et de l’offre limitée. Certains acheteurs ont également réévalué leurs critères de recherche, car la hausse du prix des propriétés et la nouvelle possibilité de travailler à distance pèsent dans leur&nbsp;décision."
	},

	"m.usage.covid.c": {
		"en": "On the other hand, sellers have indicated some hesitancy to list their properties for sale as they remain wary of open houses during the pandemic. They’re also concerned about the prospect of finding a new property within their criteria to relocate to under uncertain market conditions.",
		"fr": "D’autre part, les propriétaires-vendeurs hésitent à mettre leur propriété en vente, car ils se méfient des visites libres pendant la pandémie. Ils s’inquiètent également de la perspective de trouver une nouvelle propriété répondant à leurs critères pour s’installer dans des conditions de marché&nbsp;incertaines."
	},

	"m.usage.covid.graphtitle": {
		"en": "How has COVID&#8209;19 affected consumers' intentions?",
		"fr": "Comment la COVID-19 a-t-elle influencé les intentions des consommateurs?"
	},

	"m.usage.title": {
		"en": "REALTOR.ca Account Holders",
		"fr": "Comptes d’utilisateurs sur REALTOR.ca"
	},

	"m.usage.intro.a": {
		"en": "There are more than 1.1 million REALTOR.ca accounts, and that number continues to grow with an average 25,000 new accounts created each month.",
		"fr": "Il y a plus de 1,1 million de comptes d’utilisateurs sur REALTOR.ca, et ce chiffre continue d’augmenter; en effet, environ 25 000 nouveaux comptes sont créés chaque mois."
	},

	"m.usage.intro.b": {
		"en": "In 2021, 300,000 REALTOR.ca accounts were created.",
		"fr": "En 2021, 300 000 comptes ont été créés sur REALTOR.ca."
	},

	"m.usage.intro.c": {
		"en": "REALTOR.ca account holders are six times more likely to convert to a lead through the platform than non-account holders.",
		"fr": "Les utilisateurs de REALTOR.ca ayant créé un compte sont six fois plus susceptibles de devenir des clients potentiels lorsqu’ils utilisent REALTOR.ca que les visiteurs qui n’ont pas de compte."
	},

	"m.usage.card.a.stat": {
		"en": "<span class=\"stat__number\">1.1</span> million",
		"fr": "<span class=\"stat__number\">1,1</span> million"
	},

	"m.usage.card.a.text": {
		"en": "total REALTOR.ca accounts",
		"fr": "de comptes d’utilisateurs sur REALTOR.ca"
	},

	"m.usage.card.b.stat": {
		"en": "<span class=\"stat__number\">300,000</span>",
		"fr": "<span class=\"stat__number\">300&nbsp;000</span>"
	},

	"m.usage.card.b.text": {
		"en": "consumer accounts were created",
		"fr": "comptes d’utilisateurs ont été créés"
	},

	"m.time.title": {
		"en": "Time Using REALTOR.ca",
		"fr": "Temps passé sur REALTOR.ca"
	},

	"m.time.duration.title": {
		"en": "Average visit duration",
		"fr": "Durée de visite moyenne"
	},

	"m.time.card.a.stat": {
		"en": "7 minutes, 29 seconds",
		"fr": "7 minutes, 29 secondes"
	},

	"m.time.card.a.text": {
		"en": "<span class=\"stat__device\">Web</span>",
		"fr": "<span class=\"stat__device\">Site Web</span>"
	},

	"m.time.card.b.stat": {
		"en": "5 minutes, 34 seconds",
		"fr": "5 minutes, 34 secondes"
	},

	"m.time.card.b.text": {
		"en": "<span class=\"stat__device\">App</span>",
		"fr": "<span class=\"stat__device\">Application mobile</span>"
	},

	"m.time.card.rear": {
		"en": "Canadian visitors spend almost two and a half minutes more on REALTOR.ca than the average real estate industry platform.",
		"fr": "Les utilisateurs canadiens ont passé près de deux minutes et demie de plus sur REALTOR.ca que sur d’autres plateformes&nbsp;immobilières."
	},

	"m.time.card.c.stat": {
		"en": "<span class=\"stat__number\">+13%</span>",
		"fr": "<span class=\"stat__number\">+13&nbsp;%</span>"
	},

	"m.time.card.c.text": {
		"en": "Peak traffic times differ depending on how visitors are using REALTOR.ca. Traffic from visitors using REALTOR.ca on desktop peaks between 12:00 p.m. and 2:00 p.m., while mobile user traffic peaks between 8:00 p.m. and&nbsp;10:00&nbsp;p.m.",
		"fr": "Les périodes de pointe des recherches dépendent de la façon dont les visiteurs utilisent REALTOR.ca. Dans le cas des visiteurs qui utilisent un ordinateur, la période de pointe est de midi à 14&nbsp;h, tandis que dans le cas des visiteurs qui utilisent un appareil mobile, elle se déroule de 20&nbsp;h à 22&nbsp;h."
	},


	// Heat Map
	"m.heatmap.label": {
		"en": "sessions",
		"fr": "séances"
	},

	"m.heatmap.mobile.title": {
		"en": "Mobile Traffic",
		"fr": "Appareil mobile"
	},

	"m.heatmap.desktop.title": {
		"en": "Desktop Traffic",
		"fr": "Ordinateur"
	},

	"m.heatmap.day.noon": {
		"en": "Noon",
		"fr": "Midi"
	},

	"m.heatmap.day.scale.bottom": {
		"en": "11 PM",
		"fr": "23 H"
	},

	"m.heatmap.day.scale.top": {
		"en": "12 AM",
		"fr": "Minuit"
	},

	"m.heatmap.day.mon": {
		"en": "Mon",
		"fr": "Lun."
	},

	"m.heatmap.day.tue": {
		"en": "Tue",
		"fr": "Mar."
	},

	"m.heatmap.day.wed": {
		"en": "Wed",
		"fr": "Mer."
	},

	"m.heatmap.day.thu": {
		"en": "Thu",
		"fr": "Jeu."
	},

	"m.heatmap.day.fri": {
		"en": "Fri",
		"fr": "Ven."
	},

	"m.heatmap.day.sat": {
		"en": "Sat",
		"fr": "Sam."
	},

	"m.heatmap.day.sun": {
		"en": "Sun",
		"fr": "Dim."
	},

	// Devices Used
	"m.devices.title": {
		"en": "Devices Used",
		"fr": "Appareil utilisé"
	},

	"m.devices.intro": {
		"en": "While mobile devices continue to be the preferred method for browsing real estate, desktop usage has increased in 2021. This is likely due to Canadians spending more time at home as pandemic restrictions remain predominantly in place.",
		"fr": "Alors que les appareils mobiles restent la méthode préférée pour les recherches immobilières, l’utilisation d’un ordinateur de bureau a augmenté en 2021. Cela s’explique probablement par le fait que les Canadiens passent plus de temps à la maison, les restrictions dues à la pandémie restant principalement en place."
	},

	"m.devices.card.a.stat": {
		"en": "<span class=\"stat__number\">29%</span>",
		"fr": "<span class=\"stat__number\">29&nbsp;%</span>"
	},

	"m.devices.card.a.text": {
		"en": "of REALTOR.ca visitors were on desktop devices.",
		"fr": "des visites ont été effectuées sur un ordinateur."
	},

	"m.devices.card.b.stat": {
		"en": "<span class=\"stat__number\">71%</span>",
		"fr": "<span class=\"stat__number\">71&nbsp;%</span>"
	},

	"m.devices.card.b.text": {
		"en": "of REALTOR.ca visitors were on mobile devices.",
		"fr": "des visites ont été effectuées sur un appareil mobile."
	},

	"m.realtorapp.paragraph.text": {
		"en": "The REALTOR.ca app has a new and improved look and feel, making it easier than ever for consumers to search for their dream home and connect with a REALTOR®. Share the app with your clients today!",
		"fr": "L’interface et la convivialité de l’application REALTOR.ca ont été améliorées, ce qui permet aux consommateurs de rechercher plus facilement que jamais la maison de leurs rêves et d’entrer en contact avec un courtier ou agent. Parlez-en avec vos clients."
	},


    // Apple store badge image src
    "m.realtorapp.applestore.src": {
        "en": "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1591228800&h=0347c20784fc18bb5231c89d4c689010",
        "fr": "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/fr-ca?size=250x83&amp;releaseDate=1591228800&h=0347c20784fc18bb5231c89d4c689010"
    },

    // Apple store badge image href
    "m.realtorapp.applestore.href": {
        "en": "https://apps.apple.com/ca/app/realtor-ca-real-estate-homes/id408873309?itsct=apps_box_badge&amp;itscg=30200",
        "fr": "https://apps.apple.com/ca/app/realtor-ca/id408873309?l=fr"
    },

    // Apple store badge image alt
    "m.realtorapp.applestore.alt": {
        "en": "Download on the App Store",
        "fr": "Télécharger dans l'App Store"
    },

    // Google Play badge image src
    "m.realtorapp.googleplay.src": {
        "en": "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png",
        "fr": "https://play.google.com/intl/fr_ca/badges/static/images/badges/fr_badge_web_generic.png"
    },

    // Google Play badge image href
    "m.realtorapp.googleplay.href": {
        "en": "https://play.google.com/store/apps/details?id=ca.crea.app.consumer&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png",
        "fr": "https://play.google.com/store/apps/details?id=ca.crea.app.consumer&hl=fr"
    },

    // Google Play badge image alt
    "m.realtorapp.googleplay.alt": {
        "en": "Get it on Google Play",
        "fr": "Disponible sur Google Play"
    },

	// "m.devices.card.b.rear": {
	// 	"en": "<span class=\"line\">39% REALTOR.ca mobile&nbsp;browser</span> <span class=\"line\">30% REALTOR.ca from the&nbsp;mobile&nbsp;apps</span>",
	// 	"fr": "<span class=\"line\">39&nbsp;%&nbsp;site Web REALTOR.ca sur appareil mobile</span> <span class=\"line\">30&nbsp;%&nbsp;application mobile REALTOR.ca</span>"
	// },

	// International
	"m.international.title": {
		"en": "International",
		"fr": "Visiteurs internationaux"
	},

	"m.international.intro.a": {
		"en": "International traffic has increased—though at a lower rate than domestic traffic—with 14.9 million international visits in 2021, compared to 12.3 million international visits in 2020.",
		"fr": "L’achalandage international a connu une hausse, mais à un taux de croissance inférieur à celui de l’achalandage national.  Il y a eu 14,9&nbsp;millions de visites en provenance d’autres pays en 2021, comparativement à 12,3&nbsp;millions en 2020."
	},

	"m.international.intro.b": {
		"en": "In 2021, there were six million international visitors (an increase of 24% from 2020) and 155,000 international leads generated (up 27% from 2020).",
		"fr": "En 2021, il y a eu 6&nbsp;millions de visiteurs internationaux (une hausse de 24&nbsp;% par rapport à 2020) et 155&nbsp;000 clients internationaux potentiels (une hausse de 27&nbsp;% par rapport à 2020)."
	},

	"m.international.card.a.stat": {
		"en": "<span class=\"stat__number\">5%</span>",
		"fr": "<span class=\"stat__number\">5&nbsp;%</span>"
	},

	"m.international.card.a.text": {
		"en": "of all visitors to REALTOR.ca are international.",
		"fr": "de tous les visiteurs de REALTOR.ca sont des visiteurs internationaux"
	},

	"m.international.card.b.stat": {
		"en": "<span class=\"stat__number\">3%</span>",
		"fr": "<span class=\"stat__number\">3&nbsp;%</span>"
	},

	"m.international.card.b.text": {
		"en": "of all leads REALTORS® receive are from international visitors.",
		"fr": "de tous les clients potentiels dirigés vers nos membres sont des visiteurs internationaux"
	},

	"m.creaglobal.paragraph.text": {
		"en": "Are you part of CREA Global? Easily grow your business, expand your network and exchange referral opportunities across the border and beyond.",
		"fr": "Participez-vous au programme ACI – International? Faites croître facilement votre entreprise, élargissez votre réseau et échangez des occasions d’aiguillage au-delà des frontières."
	},

    "m.creaglobal.link.href": {
        "en": "https://www.realtorlink.ca/content/realtorlink/crea/en_CA/tech-tools---services0/global.html",
        "fr": "https://www.realtorlink.ca/content/realtorlink/crea/fr_CA/tech-tools---services0/international-real-estate.html"
    },

	"m.creaglobal.link.text": {
		"en": "Learn more",
		"fr": "Voir les détails"
	},

	"m.sources.section.title": {
		"en": "Higher Search Engine Recognition",
		"fr": "Plus grande reconnaissance dans les moteurs de recherche"
	},

	"m.sources.chart.title": {
		"en": "Visits from Organic Search",
		"fr": "Visites attribuables au référencement naturel"
	},

	// BEHAVIOURAL INSIGHTS FOOTER -------------------------------------------------------- //

	"report.footer.report.title": {
		"en": "Looking Forward",
		"fr": "Tournés vers l’avenir"
	},

	"report.footer.report.paragraph1": {
		"en": "Let’s continue to raise the bar. We value your feedback and are always looking for ways to make this report more useful to you and your business. Please help us do so by providing your valuable feedback through this brief survey.",
		"fr": "Continuons de relever la barre. Nous avons à cœur votre opinion et cherchons sans cesse des façons d’améliorer ce rapport afin qu’il soit utile à vous et à votre entreprise. Veuillez nous aider en nous faisant part de vos précieux commentaires par le biais de ce bref sondage."
	},

	// "report.footer.report.paragraph1": {
	// 	"en": "Let’s continue to raise the bar. We value your feedback and are always looking for ways to make this report more useful to you and your business.",
	// 	"fr": "Continuons de relever la barre. Nous avons à cœur votre opinion et cherchons sans cesse des façons d’améliorer ce rapport afin qu’il soit utile à vous et à votre entreprise."
	// },	

	"report.footer.report.paragraph2": {
		"en": "If you have any questions, you’re encouraged to get in touch with us at <a href=\"mailto:support@crea.ca\">support@crea.ca</a>.",
		"fr": "Si vous avez des questions, communiquez avec nous au <a href=\"mailto:support@crea.ca\">support@crea.ca</a>."
	},

	"report.footer.report.insights.text": {
		"en": "Discover valuable regional data with REALTOR.ca Local Insights.",
		"fr": "Découvrez des données régionales qui vous seront utiles grâce aux Données locales de REALTOR.ca."
	},

	"report.footer.report.insights.button": {
		"en": "Go to REALTOR.ca Local Insights",
		"fr": "Consulter les Données locales"
	},

	"local.footer.report.insights.text": {
		"en": "Discover valuable insights through our 2020 REALTOR.ca Insights Report.",
		"fr": "Découvrez plus de données utiles grâce aux Rapport sur les données d’utilisation de&nbsp;REALTOR.ca."
	},

	"local.footer.report.insights.button": {
		"en": "Go to Insights Report",
		"fr": "Rapport sur les données d’utilisation de REALTOR.ca"
	},
	// LOCAL INSIGHTS LOADING ------------------------------------------------------------ //

	"loading.msg": {
		"en": "We're just loading the most recent data for&nbsp;%s. This could take a minute or so, but we‘ll start loading data as it becomes available!",
		"fr": "Téléchargement des données pour&nbsp;%s en cours. Cela pourrait prendre quelques minutes. Les données s’afficheront au fur et à mesure qu’elles seront disponibles!"
	},

	"error.missing.locale": {
		"en": "Data for the locale “%s” is only available from 2023 onwards.",
		"fr": "Les données pour “%s” ne sont disponibles que depuis 2023."
	},	

	// LOCAL INSIGHTS INTRO -------------------------------------------------------------- //

	"local.intro.title": {
		"en": "REALTOR.ca Local Insights",
		"fr": "Données locales de REALTOR.ca"
	},

	"local.intro.content": {
		"en": "Discover what REALTOR.ca visitors are looking for in the areas you care about. Filter by city below to see how REALTOR.ca visitors across Canada are using REALTOR.ca, including what keywords they search for, their top search filters, demographic information and much more.",
		"fr": "Découvrez ce que les visiteurs de REALTOR.ca cherchent dans les régions qui sont importantes pour vous. Filtrez les données par ville ci-dessous pour savoir comment les visiteurs canadiens utilisent REALTOR.ca, comme les mots-clés les plus recherchés, les filtres les plus utilisés, les données démographiques, et bien plus encore."
	},

	"local.intro.notice": {
		"en": "We’re still crunching the numbers on 2020’s local data. Come back in March for detailed local insights. For now, 2019’s numbers can be found below.",
		"fr": "Nous sommes encore en train d’analyser les données locales de 2020. Elles seront disponibles en mars. Entre-temps, vous pouvez consulter les données de 2019 ci-dessous."
	},

	// Filters

	"local.filters.title": {
		"en": "Filter data by:",
		"fr": "Filtrer les données par : "
	},

	"local.filters.city.label": {
		"en": "City",
		"fr": "Ville"
	},

	"local.filters.date.label": {
		"en": "Date Range",
		"fr": "Dates"
	},

	"local.filters.button.update": {
		"en": "Update",
		"fr": "Afficher"
	},

	"local.filters.button.updatecity": {
		"en": "Update City",
		"fr": "Afficher"
	},


	"local.filters.30daysago": {
		"en": "Last 30 Days",
		"fr": "Derniers 30 jours"
	},

	"local.filters.7daysago": {
		"en": "Last 7 Days",
		"fr": "Derniers 7 jours"
	},

	"local.filters.3months": {
		"en": "Last 3 Months",
		"fr": "Derniers 3 mois"
	},

	"local.filters.1year": {
		"en": "Last Year",
		"fr": "Dernière année"
	},

    "local.filters.disclaimer": {
        "en": " ",
        "fr": "En raison de limitations techniques, certaines des étiquettes de données ci-dessous sont présentées en anglais seulement. Nous vous remercions de votre patience alors que nous cherchons une solution."
    },

	// Neighbourhoods
	"local.neighbourhoods.title": {
		"en": "Neighbourhoods of listings visited",
		"fr": "Quartiers des inscriptions consultées"
	},

	"local.neighbourhoods.intro": {
		"en": "Find out which neighbourhoods have garnered the most interest by REALTOR.ca visitors in %s",
		"fr": "Découvrez quels quartiers ont suscité le plus d’intérêt chez les visiteurs de REALTOR.ca à %s"
	},
	
	"local.neighbourhoods.heading": {
		"en": "Top Ranking Neighbourhoods",
		"fr": "Quartiers les mieux cotés"
	},	

	"local.neighbourhoods.select": {
		"en": "Select Neighbourhood",
		"fr": "Sélectionner le quartier"		
	},

	"local.provincial.title": {
		"en": "Interprovincial listing searches",
		"fr": "Recherches d’inscriptions dans d’autres provinces"
	},	

	"local.provincial.intro": {
		"en": "Discover whether REALTOR.ca visitors in %s are searching for real estate locally or in a different province.",
		"fr": "Découvrez si les visiteurs de REALTOR.ca à %s cherchent des propriétés locales ou dans une autre province."
	},	

	"local.provincial.legend": {
		"en": "%s Visitors",
		"fr": "%s Visiteurs"
	},	
	
	"local.provincial.visitors": {
		"en": "Visitors",
		"fr": "Visiteurs"
	},		


	// Region Table Headers
	"local.region.table.rank": {
		"en": "Rank",
		"fr": "Cote"
	},
	
	"local.region.table.visitors": {
		"en": "Visitors",
		"fr": "Visiteurs"
	},	

	"local.region.table.neighbourhood": {
		"en": "Neighbourhood",
		"fr": "Quartier"
	},			

	"local.region.table.percentagerank": {
		"en": "% Visitors",
		"fr": "% Visiteurs"
	},			

	"local.region.table.numberrank": {
		"en": "# Visitors",
		"fr": "# Visiteurs"
	},			
	

		// Search Trends
	"local.searchtrends.title": {
		"en": "Search Behaviour",
		"fr": "Comportement de recherche"
	},

	// Top search terms

	"local.terms.legend": {
		"en": "= Total Visitors",
		"fr": ""
	},	

	"local.searchtrends.terms": {
		"en": "Top Search Terms",
		"fr": "Mots-clés les plus recherchés"
	},

	"local.searchtrends.terms.intro": {
		"en": "Explore the top geographic areas REALTOR.ca visitors are searching for properties in and the top keywords they are using when searching for listing features.",
		"fr": "Explorez les principales régions géographiques dans lesquelles les visiteurs de REALTOR.ca recherchent des propriétés et les principaux mots-clés qu’ils utilisent pour chercher les caractéristiques de propriétés."
	},

	"local.searchtrends.geographic.title": {
		"en": "Cities and Neighbourhoods&nbsp;Searched",
		"fr": "Villes et <br>quartiers recherchés"
	},

	"local.searchtrends.geographic.intro": {
		"en": "Geographic search terms are gathered from cities and neighbourhoods that visitors enter into the primary search bar on REALTOR.ca",
		"fr": "Les lieux géographiques interrogés sont compilés à partir des villes et des quartiers indiqués par les visiteurs dans la barre de recherche principale de REALTOR.ca."
	},

	"local.searchtrends.keyword.title": {
		"en": "Keywords <br>Searched",
		"fr": "Mots-clés <br>recherchés"
	},

	"local.searchtrends.keyword.intro": {
		"en": "Keywords are gathered from what a visitor enters into the keyword search field, found in the “filters” section of REALTOR.ca",
		"fr": "Les mots-clés sont compilés à partir des mots indiqués par les visiteurs dans le champ de recherche Mots-clés à la section « Filtres » de REALTOR.ca."
	},

	// Top search filters
	"local.searchtrends.filters": {
		"en": "Top Search Filters",
		"fr": "Filtres de recherche les plus utilisés"
	},

	"local.searchtrends.filters.intro": {
		"en": "REALTOR.ca visitors use filters to search for properties that fit their needs. Have a look at which search filters are most often used by REALTOR.ca visitors.",
		"fr": "Les visiteurs de REALTOR.ca utilisent des filtres de recherche pour trouver des propriétés qui correspondent à leurs besoins. Découvrez quels filtres de recherche sont les plus utilisés par les visiteurs de REALTOR.ca."
	},

	"local.searchtrends.filters.pricemin": {
		"en": "Minimum Price",
		"fr": "Prix min"
	},

	"local.searchtrends.filters.pricemax": {
		"en": "Maximum Price",
		"fr": "Prix max"
	},

	"local.searchtrends.filters.bedrooms": {
		"en": "Bedrooms",
		"fr": "Chambres"
	},

	"local.searchtrends.filters.bathrooms": {
		"en": "Bathrooms",
		"fr": "Bains"
	},

	"local.searchtrends.filters.landsize": {
		"en": "Land Size",
		"fr": "Superficie du terrain"
	},

	"local.searchtrends.filters.buildingtype": {
		"en": "Building Type",
		"fr": "Type de bâtiment"
	},

	"local.searchtrends.filters.residentialpropertytype": {
		"en": "Residential Property&nbsp;Type",
		"fr": "Type de propriété résidentielle"
	},

	"local.searchtrends.filters.commercialpropertytype": {
		"en": "Commercial Property&nbsp;Type",
		"fr": "Type de propriété commerciale"
	},


	// Top neighbourhoods
	"local.searchtrends.neighbourhoods": {
		"en": "Top Neighbourhoods Viewed",
		"fr": "Quartiers les plus consultés"
	},

	"local.searchtrends.neighbourhoods.intro": {
		"en": "Dig into the top neighborhoods with the most listing views by REALTOR.ca visitors. ",
		"fr": "Découvrez les quartiers les plus recherchés, soit ceux dont les inscriptions sont les plus consultées par les visiteurs de REALTOR.ca."
	},

	// Usage Trends
	"local.usage.title": {
		"en": "Usage Behaviour",
		"fr": "Comportement d’utilisation"
	},

	// Device Breakdown
	"local.usage.devices": {
		"en": "Device Breakdown",
		"fr": "Type d’appareil"
	},

	"local.usage.devices.desktop": {
		"en": "desktop",
		"fr": "ordinateur"
	},

	"local.usage.devices.mobile": {
		"en": "mobile",
		"fr": "appareil mobile"
	},

	"local.usage.devices.tablet": {
		"en": "tablet",
		"fr": "tablette"
	},

	"local.usage.devices.intro": {
		"en": "Are REALTOR.ca visitors viewing listings on desktop computers or mobile phones? Find out what devices visitors are using to search REALTOR.ca.",
		"fr": "Les visiteurs de REALTOR.ca utilisent-ils un ordinateur ou un téléphone cellulaire pour consulter des inscriptions? Découvrez quel appareil les visiteurs utilisent pour faire des recherches sur REALTOR.ca."
	},

	// Social sharing
  "local.demographics.title": {
		"en": "Demographics",
		"fr": "Données démographiques"
	},

	"local.usage.socialshare": {
		"en": "Social Sharing",
		"fr": "Partage sur les réseaux sociaux"
	},

	"local.usage.socialshare.intro": {
		"en": "Are listings being shared on Facebook or retweeted on Twitter? Explore the social media sharing behavior of REALTOR.ca visitors.",
		"fr": "Les inscriptions sont-elles partagées sur Facebook ou sur Twitter? Explorez le comportement lié au partage sur les réseaux sociaux des visiteurs de REALTOR.ca."
	},

	// Demographics
	"local.social.sharing.devices": {
		"en": "Social Sharing by Devices",
		"fr": "Partage sur les médias sociaux selon le type d’appareil"
	},

	// Demographics
	"local.social.sharing.listings": {
		"en": "Social Sharing of Listings",
		"fr": "Partage d’inscriptions sur les médias sociaux"
	},

	// Demographics
	"local.social.sharing.nonlistings": {
		"en": "Social Sharing of Non-listing Content",
		"fr": "Partage d’autre contenu sur les médias sociaux"
	},


	"local.demographics.intro": {
		"en": "Who is searching for real estate on REALTOR.ca? Learn more about the age, gender and other characteristics of visitors searching for real estate on REALTOR.ca.",
		"fr": "Qui sont ces personnes qui recherchent des propriétés sur REALTOR.ca? Apprenez-en davantage sur les visiteurs de REALTOR.ca, notamment, leur âge, leur genre et d’autres caractéristiques."
	},

  // Age
	"m.local.age": {
		"en": "Age of Users",
		"fr": "Âge des utilisateurs"
	},

  // User Personas
	"m.local.personas": {
		"en": "User personas",
		"fr": "Profil des utilisateurs"
	},

	// Short Term Intention
	"m.local.shortTermIntention": {
		"en": "Next 6 months intention",
		"fr": "Intention pour les 6 prochains mois"
	},	
		
  // Gender
	"m.local.gender": {
		"en": "Gender*",
		"fr": "Genre*"
	},

	"m.local.gender.disclaimer": {
		"en": "*REALTOR.ca data is collected via Google Analytics which is restricted to male or female categorizations. REALTOR.ca acknowledges that this data is limited and not representative of all gender expressions.",
		"fr": "*Les données de REALTOR.ca sont recueillies par l’intermédiaire de Google Analytics qui les classe uniquement dans les catégories « Hommes » et « Femmes ». REALTOR.ca reconnaît que ces données sont limitées et qu’elles ne représentent pas toutes les expressions de genre."
	},	

	"m.local.gender.female": {
		"en": "Female",
		"fr": "Femmes"
	},

	// Demographics
	"m.local.gender.male": {
		"en": "Male",
		"fr": "Hommes"
	},

	// Footer
	"local.footer.paragraph1" : {
		"en": "Let’s continue to raise the bar. We value your feedback and are always looking for ways to make this report more useful to you and your business. Please help us do so by providing your valuable feedback through this brief survey.",
		"fr": "Continuons de relever la barre. Nous avons à cœur votre opinion et cherchons sans cesse des façons d’améliorer ce rapport afin qu’il soit utile à vous et à votre entreprise. Veuillez prendre quelques minutes afin de répondre à ce bref sondage et de nous faire part de vos commentaires."
	},

	// "local.footer.paragraph1": {
	// 	"en": "Let’s continue to raise the bar. We value your feedback and are always looking for ways to make this report more useful to you and your business.",
	// 	"fr": "Continuons de relever la barre. Nous avons à cœur votre opinion et cherchons sans cesse des façons d’améliorer ce rapport afin qu’il soit utile à vous et à votre entreprise."
	// },	

	"local.footer.paragraph2" : {
		"en": "If you have any questions, you’re encouraged to get in touch with us at <a href=\"mailto:support@crea.ca\">support@crea.ca</a>.",
		"fr": "Si vous avez des questions, n’hésitez pas à communiquer avec nous au <a href=\"mailto:support@crea.ca\">support@crea.ca</a>"
	},

	// "local.footer.realtor" : {
	// 	"en": "©2022 The Canadian Real Estate Association. All rights reserved. The trademarks REALTOR®, REALTORS® and the REALTOR® logo are controlled by CREA and identify real estate professionals who are members of CREA.",
	// 	"fr": "© 2022 L’Association canadienne de l’immobilier (ACI). Tous droits réservés. Les marques de commerce REALTOR® et REALTORS®, de même que le logo REALTOR®, sont sous le contrôle de l’ACI et désignent les professionnels de l’immobilier qui sont membres de l’ACI."
	// },

	"local.footer.realtor": {
		"en": "@CY The Canadian Real Estate Association. All rights reserved. The trademarks REALTOR®, REALTORS® and the REALTOR® logo are controlled by CREA and identify real estate professionals who are members of CREA.",
		"fr": "@CY L’Association canadienne de l’immobilier (ACI). Tous droits réservés. Les marques de commerce REALTOR® et REALTORS®, de même que le logo REALTOR®, sont sous le contrôle de l’ACI et désignent les professionnels de l’immobilier qui sont membres de l’ACI."
	},	

	"local.footer.mls" : {
		"en": "The MLS ® mark and associated logos are owned by CREA and identify professional services rendered by REALTOR® members of CREA to effect the purchase, sale, and lease of real estate as part of a cooperative selling system.",
		"fr": "La marque MLS® et les logos connexes sont la propriété de l’ACI et désignent les services professionnels rendus par les membres de l’ACI aux fins de transactions d’achat, de vente et de location de biens immobiliers dans le cadre d’un système de vente collaborative."
	},

	"local.footer.sources" : {
		"en": "Sources: Local Insights are developed using data from Google Analytics tracking of REALTOR.ca (web and mobile apps).",
		"fr": "Sources : Les Données locales sont tirées de l’analyse effectuée par Google Analytics de REALTOR.ca (Web et applications mobiles)."
	},

	"local.footer.image.alt": {
		"en": "Happy couple browsing gazing out a large window",
		"fr": "Un couple heureux regardant par une grande fenêtre."
	},


	// SOCIAL SHARING ------------------------------------------------------------------ //

	"share.facebook": {
		"en": "View the 2021 REALTOR.ca Insights Report",
		"fr": ""
	},

	"share.tweet": {
		"en": "Take a peek at REALTOR.ca Local Insights",
		"fr": "Jetez un coup d’œil aux Données locales de REALTOR.ca"
	},

	"share.linkedin": {
		"en": "View the 2021 REALTOR.ca Insights Report",
		"fr": ""
	},

	"share.email": {
		"en": "Take a peek at REALTOR.ca Local Insights",
		"fr": "Jetez un coup d’œil aux Données locales de REALTOR.ca"
	},

	"working.text" : {
		"en": "Working",
		"fr": "En attente"
	},


	// BAR CHART LABELS -------------------------------------------------------------- //
	//
	"barchart.label._Direct" : {
		"en": "Direct",
		"fr": "Direct"
	},

	"barchart.label._Organic_Search" : {
		"en": "Organic Search",
		"fr": "Recherche organique"
	},

	"barchart.label._Social" : {
		"en": "Social",
		"fr": "Médias sociaux"
	},

	"barchart.label._Social" : {
		"en": "Social",
		"fr": "Médias sociaux"
	},

	"barchart.label._Referral" : {
		"en": "Referral",
		"fr": "Recommandation"
	},

	"barchart.label._Email" : {
		"en": "Email",
		"fr": "Courriel"
	},

	"barchart.label._Paid_Search" : {
		"en": "Paid Search",
		"fr": "Recherche payée"
	},

	"barchart.label._Delayed_Purchase": {
		"en": "Delayed Purchase",
		"fr": "Ont reporté un achat"
	},

	"barchart.label._Delayed_Sale": {
		"en": "Delayed Sale",
		"fr": "Ont reporté une vente"
	},

	"barchart.label._Speed_Purchase": {
		"en": "Faster Purchase",
		"fr": "Ont accéléré un achat"
	},

	"barchart.label._Speed_Sale": {
		"en": "Faster Sale",
		"fr": "Ont accéléré une vente"
	},

	// "barchart.label._Delayed_Purchase": {
	// 	"en": "Delayed Purchase",
	// 	"fr": "Mentionnent une autre influence"
	// },


	"barchart.label._Other" : {
		"en": "Other",
		"fr": "Autre"
	},

	"barchart.label._Other2": {
		"en": "Other",
		"fr": "Autre"
	},

    "barchart.label._Repeat_buyer" : {
        "en": "Repeat buyer",
        "fr": "Acheteurs déjà propriétaires"
    },

	"barchart.label._1st_time_buyer" : {
		"en": "First time buyer",
		"fr": "Acheteur d’une première propriété"
	},

	"barchart.label._Residential_investor" : {
		"en": "Residential investor",
		"fr": "Investisseur résidentiel"
	},

	"barchart.label._Seller" : {
		"en": "Seller",
		"fr": "Propriétaire-vendeur"
	},

	"barchart.label._Commercial_investor" : {
		"en": "Commercial investor",
		"fr": "Investisseur commercial"
	},

	"barchart.label._Commercial_buyer_leaser" : {
		"en": "Commercial buyer/leaser",
		"fr": "Acheteur ou locataire commercial"
	},

	"barchart.label._Land_for_development" : {
		"en": "Land for development",
		"fr": "Aménagement de terrain"
	},

	"barchart.label._Investor" : {
		"en": "Investor",
		"fr": "Investisseur"
	},

	"barchart.label._Renter" : {
		"en": "Renter",
		"fr": "Locataire"
	},

	"barchart.label._Rent_a_home": {
		"en": "Rent a home",
		"fr": "Louer une propriété"
	},	

	"barchart.label._Buy_again": {
		"en": "Buy again",
		"fr": "Acheter une autre propriété"
	},
	
	"barchart.label._Buy_a_first_home": {
		"en": "Buy a first home",
		"fr": "Acheter une première propriété"
	},	

	"barchart.label._Invest_in_a_property": {
		"en": "Invest in a property",
		"fr": "Investir dans une propriété"
	},	

	"barchart.label._Browse_listings": {
		"en": "Browse Listings",
		"fr": "Consulter les inscriptions"
	},
	
	"barchart.label._Sell_a_home": {
		"en": "Sell a home",
		"fr": "Vendre une propriété"
	},	

	"barchart.label._Track_market_trends": {
		"en": "Track market trends",
		"fr": "Faire un suivi des tendances du marché"
	},		

	"barchart.label._desktop": {
		"en": "desktop",
		"fr": "ordinateur"
	},

	"barchart.label._mobile": {
		"en": "mobile",
		"fr": "appareil mobile"
	},

	"barchart.label._tablet": {
		"en": "tablet",
		"fr": "tablette"
	},

	"barchart.label._unknown": {
		"en": "Unknown",
		"fr": "Inconnu"
	},	

	// Top Countries

	"m.topcountries.title": {
		"en": "Top Countries",
		"fr": "Principaux pays"
	},

	"m.topcountries.header.rank": {
		"en": "Rank",
		"fr": "Classement"
	},

	"m.topcountries.header.country": {
		"en": "Country",
		"fr": "Pays"
	},

	"m.topcountries.header.percent": {
		"en": "% of Total",
		"fr": "% du total"
	},

	"m.topcountries.header.change": {
		"en": "YOY Change (Visitors)",
		"fr": "Variation d’une année à l’autre (Visiteurs)"
	},

	"m.topcountries.usa": {
		"en": "United States",
		"fr": "États-Unis"
	},

	"m.topcountries.uk": {
		"en": "United Kingdom",
		"fr": "Royaume-Uni"
	},

	"m.topcountries.india": {
		"en": "India",
		"fr": "Inde"
	},

	"m.topcountries.honhkong": {
		"en": "Hong Kong",
		"fr": "Hong Kong"
	},

	"m.topcountries.australia": {
		"en": "Australia",
		"fr": "Australie"
	},

	"m.topcountries.germany": {
		"en": "Germany",
		"fr": "Allemagne"
	},

	"m.topcountries.mexico": {
		"en": "Mexico",
		"fr": "Mexique"
	},

	"m.topcountries.france": {
		"en": "France",
		"fr": "France"
	},

	"m.topcountries.china": {
		"en": "China",
		"fr": "Chine"
	},

	"m.topcountries.uae": {
		"en": "United Arab Emirates",
		"fr": "Émirats arabes unis"
	},

	"m.topcountries.brazil": {
		"en": "Brazil",
		"fr": "Brésil"
	},

	// TERM LABELS -------------------------------------------------------------------- //

	"_no_preference": {
		"en": "Any",
		"fr": "Voir tout"
	},

	"_any": {
		"en": "Any",
		"fr": "Voir tout"
	},	

	"_residential": {
		"en": "Residential",
		"fr": "Résidentielle"
	},

	"_condo_strata": {
		"en": "Condo/Strata",
		"fr": "Copropriété"
	},

	"_vacant_land": {
		"en": "Vacant Land",
		"fr": "Terrain vacant"
	},

	"_recreational": {
		"en": "Recreational",
		"fr": "Récréative"
	},

	"_multi_family": {
		"en": "Multi Family",
		"fr": "Multifamiliale"
	},

	"_agriculture": {
		"en": "Agriculture",
		"fr": "Agricole"
	},

	"_parking": {
		"en": "Parking",
		"fr": "Stationnement"
	},

	"_business": {
		"en": "Business",
		"fr": "Entreprise"
	},

	"_multi_family": {
		"en": "Multi Family",
		"fr": "Multifamiliale"
	},

	"_multi_family": {
		"en": "Multi Family",
		"fr": "Multifamiliale"
	},

	"_retail": {
		"en": "Retail",
		"fr": "Détail"
	},

	"_industrial": {
		"en": "Industrial",
		"fr": "Industriel"
	},

	"_office": {
		"en": "Office",
		"fr": "Bureau"
	},

	"_vacant_land": {
		"en": "Vacant Land",
		"fr": "Terrain vacant"
	},

	"_hospitality": {
		"en": "Hospitality",
		"fr": "Hospitalité"
	},

	"_institutional": {
		"en": "Institutional",
		"fr": "Institutionnel"
	},

	"_house": {
		"en": "House",
		"fr": "Unifamilial"
	},

	"_row_townhouse": {
		"en": "Row / Townhouse",
		"fr": "Maison en rangée"
	},

	"_apartment": {
		"en": "Apartment",
		"fr": "Appartement"
	},

	"_duplex": {
		"en": "Duplex",
		"fr": "Duplex"
	},

	"_triplex": {
		"en": "Triplex",
		"fr": "Triplex"
	},

	"_fourplex": {
		"en": "Fourplex",
		"fr": "Quadruplex"
	},

	"_garden_home": {
		"en": "Garden Home",
		"fr": "Maison à patio"
	},

	"_mobile_home": {
		"en": "Mobile Home",
		"fr": "Maison mobile"
	},

	"_manufactured_home_mobile": {
		"en": "Manufactured Home/Mobile",
		"fr": "Maison préfabriquée ou mobile"
	},

	"_special_purpose": {
		"en": "Special Purpose",
		"fr": "Usage déterminé"
	},

	"_residential_commercial_mix": {
		"en": "Residential Commercial Mix",
		"fr": "Usage mixte résidentiel, commercial"
	},

	"_manufactured_home": {
		"en": "Manufactured Home",
		"fr": "Maison préfabriquée"
	},

	"_commercial_apartment": {
		"en": "Commercial Apartment",
		"fr": "Appartement commercial"
	},

	"_two_apartment_house": {
		"en": "Two Apartment House",
		"fr": "Maison à deux logements"
	},

	"_park_model_mobile_home": {
		"en": "Park Model Mobile Home",
		"fr": "Roulottes de parc"
	},

	"_floathome": {
		"en": "Floathome",
		"fr": "Maison flottante"
	},

	// Provinces ----------------------------------------------------------------------- //

	"_ontario" : {
		"en": "Ontario",
		"fr": "Ontario"
	},

	"_alberta": {
		"en": "Alberta",
		"fr": "Alberta"
	},	

	"_british columbia": {
		"en": "British Columbia",
		"fr": "Colombie-Britannique"
	},	

	"_manitoba": {
		"en": "Manitoba",
		"fr": "Manitoba"
	},	

	"_new brunswick": {
		"en": "New Brunswick",
		"fr": "Nouveau-Brunswick"
	},	
	
	"_newfoundland & labrador": {
		"en": "Newfoundland & Labrador",
		"fr": "Terre-Neuve-et-Labrador"
	},
	
	"_northwest territories": {
		"en": "Northwest Territories",
		"fr": "Territoires du Nord-Ouest"
	},	

	"_nova scotia": {
		"en": "Nova Scotia",
		"fr": "Nouvelle-Écosse"
	},	

	"_nunavut": {
		"en": "Nunavut",
		"fr": "Nunavut"
	},	
	
	"_prince edward island": {
		"en": "Prince Edward Island",
		"fr": "Île du Prince-Édouard"
	},
	
	"_quebec": {
		"en": "Quebec",
		"fr": "Québec"
	},	

	"_saskatchewan": {
		"en": "Saskatchewan",
		"fr": "Saskatchewan"
	},
	
	"_yukon": {
		"en": "Yukon",
		"fr": "Yukon"
	},	

	// LOCALES ----------------------------------------------------------------------- //

	"chateauguay" : {
		"en": "Châteauguay",
		"fr": "Châteauguay"
	},

	"greater-sudbury" : {
		"en": "Greater Sudbury",
		"fr": "Grand Sudbury"
	},

	"halifax": {
		"en": "Halifax",
		"fr": "Halifax"
	},

	"langley-city" : {
		"en": "Langley",
		"fr": "Langley"
	},

	"langley-township" : {
		"en": "Langley Township",
		"fr": "Langley (canton)"
	},

	"levis" : {
		"en": "Lévis",
		"fr": "Lévis"
	},

	"montreal" : {
		"en": "Montréal",
		"fr": "Montréal"
	},

	"quebec-city" : {
		"en": "Québec City",
		"fr": "Québec"
	},

	"st-albert" : {
		"en": "St. Albert",
		"fr": "St. Albert"
	},

	"saint-jerome" : {
		"en": "Saint-Jérôme",
		"fr": "Saint-Jérôme"
	},

	"trois-rivieres" : {
		"en": "Trois-Rivières",
		"fr": "Trois-Rivières"
	},


	// Qualtrics
	"qualtrics.linktext": {
		"en": "brief survey",
		"fr": "bref sondage"
	},

	"qualtrics.prod.link": {
		"en": "https://crea-aci.ca1.qualtrics.com/jfe/form/SV_bgcvZ7lfdjhDf3E",
		"fr": "https://crea-aci.ca1.qualtrics.com/jfe/form/SV_bgcvZ7lfdjhDf3E?Q_Language=FR-CA"
	},

	"qualtrics.qa.link": {
		"en": "https://creaaci.yul1.qualtrics.com/jfe/preview/previewId/31ed5615-7bb6-4470-abcd-ce6c76b788a1/SV_bgcvZ7lfdjhDf3E?Q_CHL=preview&Q_SurveyVersionID=current",
		"fr": "https://creaaci.yul1.qualtrics.com/jfe/preview/previewId/31ed5615-7bb6-4470-abcd-ce6c76b788a1/SV_bgcvZ7lfdjhDf3E?Q_CHL=preview&Q_SurveyVersionID=current?Q_Language=FR-CA"
	},

	"qualtrics.dev.link": {
		"en": "https://crea.insights.test/survey",
		"fr": "http://crea-insights-fr.test/survey"
	},	


	// ForeSee Integrations

	"foresee.linktext" : {
		"en": "brief survey",
		"fr": "bref sondage"
	},

	"foresee.report.code" : {
		"en": "vF9owlnoCwfRQB0PcB4JmnyL5xLb72Vj",
		"fr": "In5bEI1JvTXFJR4hlqqQMLymYfj5QgAe"
	},

	"foresee.local.code" : {
		"en": "hWgZLPEOCuv4bhxltCV45K3p5MuXNxfx",
		"fr": "oKyiElb4Lc8PvWGb6MijlZTUXkLn0aDq"
	},

    // Dates Filter Strings
    "local.dates.quarter.first" : {
        "en": "1<sup>st</sup> Quarter,",
        "fr": "1<sup>er</sup> trimestre de"
    },

    "local.dates.quarter.second" : {
        "en": "2<sup>nd</sup> Quarter,",
        "fr": "2<sup>e</sup> trimestre de"
    },

    "local.dates.quarter.third" : {
        "en": "3<sup>rd</sup> Quarter,",
        "fr": "3<sup>e</sup> trimestre de"
    },

    "local.dates.quarter.fourth" : {
        "en": "4<sup>th</sup> Quarter, ",
        "fr": "4<sup>e</sup> trimestre de"
    },


}

export default {
  strings,
}